import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import hi from "@/locales/hi.json";
import en from "@/locales/en.json";

i18n.use(initReactI18next).init({
  resources: { hi: { translation: hi }, en: { translation: en } },
  lng: localStorage.getItem("servecor_lang") || "en",
  fallbackLng: "en",
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false },
  returnEmptyString: false,
  parseMissingKeyHandler: (key) => key,
});

document.documentElement.lang = i18n.language;

export const setLanguage = (lng) => {
  i18n.changeLanguage(lng);
  localStorage.setItem("servecor_lang", lng);
  document.documentElement.lang = lng;
};

export default i18n;
